import React from 'react'
import ultra3 from '../../images/ultra3.png'

import ultra4 from '../../images/ultra4.png'

const First_pane = () => {
  return (
    <div className=''>
           <div
        
        style={{ 
        backgroundImage: `-webkit-linear-gradient(rgba(0, 0, 0, 0.8), rgba(0, 0, 0, 0.8)), url(${ultra3})`,
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.8), rgba(0, 0, 0, 0.8)), url(${ultra3})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        paddingBottom: '50px',
        paddingTop: '100px',
        height: '120vh'
        }}
    
    
    >


        <div className='uk-container'>

            <div className='uk-grid' data-uk-grid>
                <div className='uk-width-3-4@s'>
                    
           <h1 className='light header1 uk-margin-xlarge-top' uk-scrollspy="cls: uk-animation-slide-right; repeat: true">Acci Ultra Modern Shopping Center</h1>
      
           <h5 className='light uk-margin-medium-top'
            uk-scrollspy="cls: uk-animation-fade; repeat: true">
              
Plot Number: Plot 47, Cadastral COO, Being Plot 19 & 20 under ACCI, Lugbe, Abuja.              
Plot Title:    Certificate of Occupancy <br/>
Plot Size:    10.4 Hectares <br/>
Land Use:    Commercial<br/>
Mode of Land Acquisition:     Joint Venture<br/>
Total No. Of Housing Units:    163 Stalls<br/>
Project Start Date:    April 2023<br/>

              
              </h5>
                </div>

                <div className='uk-width-1-4@s'>

                </div>
            </div>

    




        </div>
       
    </div>



     <div className='uk-container uk-text-center uk-margin-large-top' >
         <h3>The Promise</h3>
        <div className='uk-width-1-1'>
            <img src={ultra3} />
        </div>
      </div>



        <div className='uk-container uk-text-center uk-margin-large-top' >
         <h3>Ongoing Project</h3>
        <div className='uk-width-1-1'>
            <img src={ultra4} />
        </div>
      </div>




 

  
      




    </div>
  )
}

export default First_pane